import React from "react";
import { SecurityGuard, SecurityRole, Page403 } from "@duosoftbg/nacid-components";
import ARUniEntryRequestPage from "../views/pages/registers/request/arUni/ARUniEntryRequestPage";
import ARUniEntryRequestNewPage from "../views/pages/registers/request/arUni/ARUniEntryRequestNewPage";
import ARUniEntryRequestEditPage from "../views/pages/registers/request/arUni/ARUniEntryRequestEditPage";
import ARUniEntryRequestViewPage from "../views/pages/registers/request/arUni/ARUniEntryRequestViewPage";
import ARUniEntryRequestListPage from "../views/pages/registers/request/arUni/ARUniEntryRequestListPage";

export const requestRoutes = [
  {
    path: "/ar-uni-entry-request",
    element: (
      <SecurityGuard checkForRoles={[SecurityRole.AcadrecUniEntryRequestCreate]} displayOnUnauthorized={<Page403 />}>
        <ARUniEntryRequestPage />
      </SecurityGuard>
    ),
  },
  {
    path: "/ar-uni-entry-request/new",
    element: (
      <SecurityGuard checkForRoles={[SecurityRole.AcadrecUniEntryRequestCreate]} displayOnUnauthorized={<Page403 />}>
        <ARUniEntryRequestNewPage />
      </SecurityGuard>
    ),
  },
  {
    path: "/ar-uni-entry-request/list/edit",
    element: (
      <SecurityGuard checkForRoles={[SecurityRole.AcadrecUniEntryRequestCreate]} displayOnUnauthorized={<Page403 />}>
        <ARUniEntryRequestEditPage />
      </SecurityGuard>
    ),
  },
  {
    path: "/ar-uni-entry-request/list/view",
    element: (
      <SecurityGuard checkForRoles={[SecurityRole.AcadrecUniEntryRequestCreate]} displayOnUnauthorized={<Page403 />}>
        <ARUniEntryRequestViewPage />
      </SecurityGuard>
    ),
  },
  {
    path: "/ar-uni-entry-request/list",
    element: (
      <SecurityGuard checkForRoles={[SecurityRole.AcadrecUniEntryRequestCreate]} displayOnUnauthorized={<Page403 />}>
        <ARUniEntryRequestListPage />
      </SecurityGuard>
    ),
  },
];
